// import React, { useState, useEffect } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import "../pages/Services.css";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faSadTear } from "@fortawesome/free-solid-svg-icons";

// const services = [
//   // {
//   //   title: "Chemistry - Chemical Kinetics, HydroCarbon & G-14",
//   //   pdfUrl:
//   //     "https://drive.google.com/file/d/1TX4tI9HY9Upgk0W7D22UmoODbhZS2mjU/preview",
//   // },
//   // Add more services as needed
// ];

// const Notes = () => {
//   const [expandedPdf, setExpandedPdf] = useState(null);
//   const [searchTerm, setSearchTerm] = useState("");

//   useEffect(() => {
//     AOS.init({
//       duration: 1000,
//       easing: "ease-in-out",
//       once: true,
//     });
//   }, []);

//   const expandPdf = (pdfUrl) => {
//     setExpandedPdf(pdfUrl);
//   };

//   const closePdf = () => {
//     setExpandedPdf(null);
//   };

//   const handleSearch = (e) => {
//     setSearchTerm(e.target.value);
//   };

//   const filteredServices = services.filter((service) =>
//     service.title.toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <>
//       <section className="notes-container">
//         <h1 className="service-title hero" data-aos="fade-up">
//           Notes
//         </h1>
//         <div className="search-bar" data-aos="fade-up">
//           <input
//             type="text"
//             placeholder="Search anything..."
//             value={searchTerm}
//             onChange={handleSearch}
//           />
//         </div>
//         <div className="services">
//           {filteredServices.length > 0 ? (
//             filteredServices.map((service, index) => (
//               <div className="service" key={index} data-aos="fade-up">
//                 <h2 className="service-title">{service.title}</h2>
//                 <div className="pdf-container">
//                   <iframe
//                     src={service.pdfUrl}
//                     className={`pdf-viewer ${
//                       expandedPdf === service.pdfUrl ? "expanded" : ""
//                     }`}
//                     title={service.title}
//                     onClick={() => expandPdf(service.pdfUrl)}
//                   ></iframe>
//                   {expandedPdf === service.pdfUrl && (
//                     <div className="close-btn" onClick={closePdf}>
//                       Close PDF
//                     </div>
//                   )}
//                 </div>
//               </div>
//             ))
//           ) : (
//             <div className="coming-soon" data-aos="fade-up">
//               <FontAwesomeIcon icon={faSadTear} size="3x" />
//               <p>Available Soon</p>
//             </div>
//           )}
//         </div>
//       </section>
//     </>
//   );
// };

// export default Notes;

import React from "react";
import "./OnlineTest.css";

const Notes = () => {
  return (
    <div className="online-test-container">
      <iframe
        src="https://pdf-virid.vercel.app/notes"
        frameBorder="0"
        title="Online Test Platform"
        allow="fullscreen"
      ></iframe>
    </div>
  );
};

export default Notes;
